import { CSSObject } from '@mui/material';
import React from 'react';

import { DialogActions } from '_lib/components/DialogActions/DialogActions';
import { DialogButton } from '_lib/components/DialogButton/DialogButton';
import { DialogContent, DialogContentProps } from '_lib/components/DialogContent/DialogContent';
import {
  DialogContentTextOrMarkup,
  DialogContentTextOrMarkupProps
} from '_lib/components/DialogContentText/DialogContentText';

import { DialogWrapper, DialogVariant } from '_lib/featureComponents/DialogWrapper/DialogWrapper';

import { AsyncDialogProps, useAsyncDialog } from './useAsyncDialog';

type DialogContentItem = string | DialogContentProps['children'];

export type AlertDialogProps = Omit<AsyncDialogProps, 'dismissable'> & {
  acknowledgeButtonText?: string;
  content: DialogContentItem | DialogContentItem[];
  contentTextWhiteSpace?: DialogContentTextOrMarkupProps['whiteSpace'];
  renderMarkup?: boolean;
  dialogMaxWidth?: CSSObject['maxWidth'];
  variant?: DialogVariant;
};

const AlertDialog = (props: AlertDialogProps) => {
  const {
    acknowledgeButtonText,
    content,
    contentTextWhiteSpace,
    dialogMaxWidth,
    onClose,
    renderMarkup,
    titleText,
    ...dialogProps
  } = props;

  const handleAcknowledge = () => {
    onClose();
  };

  const contentItems = Array.isArray(content) ? content : [content];

  return (
    <DialogWrapper
      {...dialogProps}
      dismissable={false}
      onClose={onClose}
      sx={[{ '& .MuiPaper-root.MuiDialog-paper': { maxWidth: dialogMaxWidth || '400px' } }]}
      titleText={titleText || 'ATTENTION'}>
      {contentItems
        .filter((item) => !!item)
        .map((item, index) => (
          <DialogContent key={index}>
            {typeof item === 'string' ? (
              <DialogContentTextOrMarkup text={item} whiteSpace={contentTextWhiteSpace} renderMarkup={renderMarkup} />
            ) : (
              item
            )}
          </DialogContent>
        ))}
      <DialogActions>
        <DialogButton color={dialogProps.variant} text={acknowledgeButtonText || 'Ok'} onClick={handleAcknowledge} />
      </DialogActions>
    </DialogWrapper>
  );
};

export const useAlertDialog = () => useAsyncDialog(AlertDialog);
